import { ReactFlowProvider } from '@xyflow/react';
import type { ModelCanvasProps } from './contracts.js';
import type { DiagramHost } from './host.js';
import { Canvas } from './Canvas.js';
/** Call once at composition time so the returned component identity remains stable. */
export function createModelCanvas(host: DiagramHost) {
  return function ModelCanvas(props: ModelCanvasProps) {
    return <ReactFlowProvider><Canvas {...props} host={host} /></ReactFlowProvider>;
  };
}
